<template>
  <b-modal
    modal-class="modal"
    :ok-only="data.okOnly"
    :size="data.size || 'md'"
    :title="data.title"
    @ok="action(data.item)"
    v-model="data.popup"
    :ok-title="data.ok"
    :cancel-title="data.cancel"
  >
    <div v-html="data.msg"></div>
    <slot />
  </b-modal>
</template>
<script>
export default {
  name: "volcan-modal",
  props: ["data", "action"],
  data: function () {
    return {};
  },
  mounted: function () {},
  computed: {},
  watch: {},
  methods: {},
};
</script>
<style>
.modal {
  position: fixed; /* Stay in place front is invalid - may break your css so removed */
  padding-top: 100px; /* Location of the box - don't know what this does?  If it is to move your modal down by 100px, then just change top below to 100px and remove this*/
}
</style>



// WEBPACK FOOTER //
// components/AdminTools/divers/modal.vue